<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="product-cost1">
                    <icon name="boxes"></icon>
                    โฟม
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-cost2">
                    <icon name="download"></icon>
                    แก้ว,ฝา,แก้วชุด,PP
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-cost3">
                    <icon name="upload"></icon>
                    หลอด
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-cost4">
                    <icon name="upload"></icon>
                    ช้อน
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-cost5">
                    <icon name="upload"></icon>
                    เข่ง
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-cost6">
                    <icon name="upload"></icon>
                    กล่อง
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view/>
        </div>
    </div>
</template>

<script>
import {
    canInventoryMaterialsImport,
    canInventoryMaterialsExport
} from "../../util/Permissions"

export default {
    name: "product-weight-layout",
    computed: {
        canInventoryMaterialsImport,
        canInventoryMaterialsExport
    },
};
</script>

<style scoped></style>
